import { render, staticRenderFns } from "./PremiumPage.vue?vue&type=template&id=2afecf24&scoped=true"
import script from "./PremiumPage.vue?vue&type=script&lang=js"
export * from "./PremiumPage.vue?vue&type=script&lang=js"
import style0 from "./PremiumPage.vue?vue&type=style&index=0&id=2afecf24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afecf24",
  null
  
)

export default component.exports